module.exports = __webpack_public_path__ + "img/oxxo.a8f205d.png";